<div class="ticker">
  <div
    class="icon-wrapper"
    [class]="getIconClass()"
  >
    <i [class]="'dx-icon dx-icon-' + icon"></i>
  </div>
  <div class="middle">
    <div class="title">
      {{ titleText }}
    </div>
    <div class="value">
      {{ value }} <span *ngIf="isPercentageValue">%</span>
    </div>
  </div>
  <div *ngIf="changePercentage !== 0"
    class="percentage"
    [class]="changePercentage > 0 ? 'positive': 'negative'"
  >
    <div [class]="'dx-icon-'+ (changePercentage > 0 ? 'spinup' : 'spindown')"></div>
    <i class="percentage-value"></i>
    <span>{{ abs(changePercentage) }}%</span>
  </div>
</div>